import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import QuestionnaireAnswerDisplay from "./QuestionnaireAnswerDisplay";
import { MultipleQuestionnaireContainer } from "@rdcs/dap-front-library";

import QuestionnaireListDisplay from "./QuestionnaireListDisplay";

const MultiplePastQuestionnaires = ({
    questionnaires,
    questionnaireList,
    isInsulinoTreated,
    breakScoreQuestions,
    breakScoreNoInsulinQuestions,
    setFillNewQuestionnaire,
}) => {
    const [indexToDisplay, setIndexToDisplay] = React.useState(0);

    return (
        <MultipleQuestionnaireContainer>
            <QuestionnaireListDisplay
                questionnaireList={questionnaireList}
                setIndexToDisplay={setIndexToDisplay}
                indexToDisplay={indexToDisplay}
                setFillNewQuestionnaire={setFillNewQuestionnaire}
            />
            <QuestionnaireAnswerDisplay
                key={indexToDisplay}
                questions={isInsulinoTreated ? breakScoreQuestions : breakScoreNoInsulinQuestions}
                answers={questionnaires[indexToDisplay]?.answers}
                score={questionnaireList[indexToDisplay]?.score}
                singleQuestionnaire={false}
            />
        </MultipleQuestionnaireContainer>
    );
};

MultiplePastQuestionnaires.propTypes = {
    questionnaires: PropTypes.arrayOf(PropTypes.object),
    questionnaireList: PropTypes.arrayOf(PropTypes.object),
    isInsulinoTreated: PropTypes.bool.isRequired,
    breakScoreQuestions: PropTypes.arrayOf(PropTypes.object),
    breakScoreNoInsulinQuestions: PropTypes.arrayOf(PropTypes.object),
    breakScoreAnswers: PropTypes.arrayOf(PropTypes.object),
    setFillNewQuestionnaire: PropTypes.func.isRequired,
};

const mapStateToProps = ({ questions: { breakScoreQuestions, breakScoreAnswers, breakScoreNoInsulinQuestions } }) => ({
    breakScoreQuestions,
    breakScoreNoInsulinQuestions,
    breakScoreAnswers,
});

export default connect(mapStateToProps)(MultiplePastQuestionnaires);
